import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { waLink } from "../lib/whatsapp";

const LOGO = "https://martins-e-freitas-v2.vercel.app/logo.svg";

const LINKS = [
  { href: "#quem-somos", label: "Quem somos", slug: "quem-somos" },
  { href: "#servicos", label: "Serviços", slug: "servicos" },
  { href: "#como-funciona", label: "Como funciona", slug: "como-funciona" },
  { href: "#faq", label: "FAQ", slug: "faq" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleLink = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-xl bg-cream/85 border-b border-line" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a
          href="#hero"
          onClick={(e) => {
            e.preventDefault();
            handleLink("#hero");
          }}
          className="flex items-center gap-2"
          data-testid="header-logo-link"
        >
          <img src={LOGO} alt="Martins e Freitas" className="h-9 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {LINKS.map((link) => (
            <button
              key={link.href}
              onClick={() => handleLink(link.href)}
              className="font-mono text-xs uppercase tracking-[0.15em] text-ink-soft hover:text-teal-dark transition-colors duration-300"
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden lg:inline-flex items-center rounded-none border border-ink px-5 py-2.5 font-mono text-xs uppercase tracking-[0.15em] text-ink hover:bg-ink hover:text-cream transition-colors duration-300"
          data-testid="header-cta-button"
        >
          Falar com as advogadas
        </a>

        <button
          className="lg:hidden text-ink"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="lg:hidden bg-cream border-b border-line overflow-hidden"
            data-testid="mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((link) => (
                <button
                  key={link.href}
                  onClick={() => handleLink(link.href)}
                  className="text-left font-serif text-2xl text-ink"
                  data-testid={`mobile-nav-link-${link.slug}`}
                >
                  {link.label}
                </button>
              ))}
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 inline-flex items-center justify-center rounded-none bg-teal-dark px-5 py-3 font-mono text-xs uppercase tracking-[0.15em] text-cream"
                data-testid="mobile-header-cta-button"
              >
                Falar com as advogadas
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
